//QUEM RECEBE O OBJETO NA AÇÃO DO ADD PARCELAS
export const adicionarParcelaFinanciamento = (
  codigoAtivo,
  valorPresente,
  valor,
  vencimento,
  tipo,
  parcelas,
  numeroDaParcela,
  tipoParcelaEscadinha,
  tipoBalao,
  taxa,
  tipoIntermediaria,
  dataVenda
) => ({
  type: '@vendas/ADICIONA_PARCELA_FINANCIAMENTO',
  payload: {
    codigo: codigoAtivo,
    valorPresente,
    valor,
    vencimento,
    tipo,
    parcelas,
    numeroDaParcela,
    tipoParcelaEscadinha,
    tipoBalao,
    taxa,
    tipoIntermediaria,
    dataVenda,
  },
});

export const removerParcelaFinanciamento = (codigoAtivo, parcela) => ({
  type: '@vendas/REMOVE_PARCELA_FINANCIAMENTO',
  payload: {
    codigo: codigoAtivo,
    parcela,
  },
});

// W-0981 SetClub: parcela condicionante de 5% do VV, gerada direto sem passar
// pelo select de condicionantes.
export const aplicarDescontoSetclub = (codigoAtivo, valor, vencimento) => ({
  type: '@vendas/APLICAR_DESCONTO_SETCLUB',
  payload: {
    codigo: codigoAtivo,
    valor,
    vencimento,
  },
});

export const removerDescontoSetclub = codigoAtivo => ({
  type: '@vendas/REMOVER_DESCONTO_SETCLUB',
  payload: {
    codigo: codigoAtivo,
  },
});

export const removerTodasParcelasFinanciamento = codigoAtivo => ({
  type: '@vendas/REMOVE_TODAS_PARCELAS_FINANCIAMENTO',
  payload: {
    codigo: codigoAtivo,
  },
});

export const removerParcelasRegularesFinanciamento = codigoAtivo => ({
  type: '@vendas/REMOVE_PARCELAS_REGULARES_FINANCIAMENTO',
  payload: {
    codigo: codigoAtivo,
  },
});

export const atualizarParcelaFinanciamento = (
  codigoAtivo,
  parcela,
  valor,
  vencimento
) => ({
  type: '@vendas/ATUALIZA_PARCELA_FINANCIAMENTO',
  payload: {
    codigo: codigoAtivo,
    parcela,
    valor,
    vencimento,
  },
});
